export default "__VITE_ASSET__DNJeeoa1__"